(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-grid"] && !Shopify.designMode) return;
  try {
    window.TheArtShop = window.TheArtShop || {};

  /* Sort UI was removed in favour of the shipping promo. Sort is still
     reachable by URL (?sort_by=...) if we ever want to bring it back. */

  /* ── MOBILE FILTER TOGGLE ── */
  TheArtShop.toggleMobileFilters = function(btn) {
    var sidebar = document.querySelector('.facets-sidebar');
    var isOpen  = btn.getAttribute('aria-expanded') === 'true';

    btn.setAttribute('aria-expanded', !isOpen);

    if (sidebar) {
      sidebar.classList.toggle('is-open', !isOpen);
    }
  };
  } catch(e) { console.error(e); }
})();

})();
